// Path: ./src/app/pages/CreateStorePage/handleSaveStore.ts
import { UpdateGfStoreDto } from "@swagger/typescript-fetch-goflyer";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import i18n from "i18next";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useNavigate } from "react-router-dom";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";

export const useHandleSaveStore = () => {
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  const handleSaveStore = async (updateStore?: UpdateGfStoreDto) => {
    if (!updateStore?.location?.coordinates[0]) {
      toastError(
        `${i18n.t(messages.longitude())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateStore?.location?.coordinates[1]) {
      toastError(
        `${i18n.t(messages.latitude())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateStore?.phone) {
      toastError(
        `${i18n.t(messages.Phone_Number())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateStore?.openTime) {
      toastError(`Open Time ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateStore?.closeTime) {
      toastError(`Close Time ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateStore?.saturdayOpenTime) {
      toastError(`Saturday Open Time ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateStore?.saturdayCloseTime) {
      toastError(`Saturday Close Time ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateStore?.sundayOpenTime) {
      toastError(`Sunday Open Time ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateStore?.sundayClosedTime) {
      toastError(`Sunday Open Time ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateStore?.merchant) {
      toastError(
        `${i18n.t(messages.merchant())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    const rankSet = updateStore.rank !== null && updateStore.rank !== undefined;
    const radiusSet =
      updateStore.rankRadiusLimit !== null &&
      updateStore.rankRadiusLimit !== undefined;
    if (rankSet !== radiusSet) {
      toastError(i18n.t(messages.Rank_Radius_Both_Error()));
      return;
    }
    if (rankSet && updateStore.rank! < 1) {
      toastError("Rank must be at least 1");
      return;
    }
    showLoadingScreen(true);
    updateStore.id
      ? await adminApiService.updateOneBaseGfStoreAdminControllerGfStore(
          {
            ...updateStore,
            rank: rankSet ? updateStore.rank : (null as any),
            rankRadiusLimit: radiusSet
              ? updateStore.rankRadiusLimit
              : (null as any),
          },
          updateStore.id,
          authHeaders,
        )
      : await adminApiService.createOneBaseGfStoreAdminControllerGfStore({
          ...updateStore, //This is for optional properties
          location: updateStore.location,
          phone: updateStore.phone,
          openTime: updateStore.openTime,
          closeTime: updateStore.closeTime,
          saturdayOpenTime: updateStore.saturdayOpenTime,
          saturdayCloseTime: updateStore.saturdayCloseTime,
          sundayOpenTime: updateStore.sundayOpenTime,
          sundayClosedTime: updateStore.sundayClosedTime,
          merchant: updateStore.merchant,
          rank: updateStore.rank,
          rankRadiusLimit: updateStore.rankRadiusLimit,
          signature: updateStore.signature,
          storeTag: updateStore.storeTag,
          websiteFlyerDisplayEnabled: updateStore.websiteFlyerDisplayEnabled,
          websiteFlyerReleaseDayTime: updateStore.websiteFlyerReleaseDayTime,
          websiteFlyerLatestOnly: updateStore.websiteFlyerLatestOnly,
        });
    showLoadingScreen(false);
    toastSuccess(
      `${
        updateStore.id ? i18n.t(messages.edit()) : i18n.t(messages.Create())
      } ${i18n.t(messages.stores())} `,
    );
    navigate(-1);
  };
  return handleSaveStore;
};
